import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";

import { Button } from "rbx";

import { groupBy } from "lodash";

import moment from "moment";
import TripItem from "./TripItem";
import { useOrdersByTripKey } from "../../../hooks";

import "./Trips.scss";

const TripList = ({
  activeTrip,
  setActiveTrip = () => {},
  tripKeys,
  children
}) => {
  const [activeIndex, setActiveIndex] = useState(undefined);
  const [posFixed, setPosFixed] = useState(false);
  const tripList = useRef(null);

  const { orders } = useOrdersByTripKey(tripKeys);

  useEffect(() => {
    if (typeof activeTrip !== "undefined") {
      setActiveIndex(activeTrip);
    }
  }, [activeTrip]);

  const ordersWithArrivals = orders.map(o => {
    const { PickupDate } = o;

    const LoadTime = o.Route?.LoadTime || 0;
    const TravelTime = o.Route?.TravelTime || 0;

    const result = {
      ...o,
      ArrivalDate: moment(PickupDate)
        .add(LoadTime + TravelTime, "hours")
        .toDate()
    };

    return result;
  });
  const groups = groupBy(
    ordersWithArrivals,
    o => o.TripKey || "Untripped"
    // o.Trip ? `Trip ${o.Trip}` : "Untripped"
  );

  const handleClick = index => () => {
    setActiveIndex(activeIndex === index ? undefined : index);
  };

  const items = Object.keys(groups).sort((a, b) => {
    const aVal = a.split("_")[2];
    const bVal = b.split("_")[2];
    if (aVal > bVal) return 1;
    if (bVal > aVal) return -1;
    return 0;
  });

  const activeKey = items[activeIndex];

  useEffect(() => {
    const handleScroll = () => {
      if (tripList.current) {
        const { top } = tripList.current.getBoundingClientRect();
        if (window.scrollY > top) {
          setPosFixed(true);
        } else if (window.scrollY <= top && posFixed) {
          setPosFixed(false);
        }
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  });

  useEffect(() => {
    setActiveTrip(items.includes("Untripped") ? activeIndex - 1 : activeIndex);
  }, [activeIndex, items, setActiveTrip]);

  return (
    <div
      className="trip-list-container"
      ref={tripList}
      style={
        posFixed
          ? {
              position: "fixed",
              top: 0,
              width: "calc(100% - (143px + 3rem))",
              zIndex: 99,
              transform: "translate(0, -15px)"
            }
          : {}
      }
    >
      <div className="page-head">
        <div className="page-head-start">
          <Button.Group>
            {items.map((key, i) => (
              <Button
                color="link"
                key={key}
                outlined={activeIndex !== i}
                onClick={handleClick(i)}
              >
                {key === "Untripped"
                  ? "Untripped"
                  : `Trip ${key.split("_")[2]}`}
              </Button>
            ))}
          </Button.Group>
        </div>
        {children && <div className="page-head-end">{children}</div>}
      </div>

      {activeKey && (
        <div className="trip-list">
          <TripItem
            key={activeKey}
            label={activeKey}
            legs={groups[activeKey]}
          />
        </div>
      )}
      {/* <div className="trip-list">
        {items.map((key, i) => (
          <TripItem
            key={`${key}-${i}`}
            handleClick={handleClick(i)}
            activeIndex={activeIndex}
            index={i}
            label={key}
            legs={groups[key]}
          />
        ))}
      </div> */}
    </div>
  );
};

TripList.propTypes = {
  activeTrip: PropTypes.number,
  setActiveTrip: PropTypes.func,
  children: PropTypes.node,
  tripKeys: PropTypes.arrayOf(PropTypes.string)
};
TripList.defaultProps = {
  children: null
};
export default TripList;
